// extracted by mini-css-extract-plugin
export default {"container":"SavingTranslationError_container__aK8MB"};